import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from 'src/app/its/services/authentication.service';
import { Role } from '../models/role';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

        const user = this.authenticationService.getUserValue;
        if (user?.isAuthenticated) {

            // check if route is restricted by role
            //const expectedRole = route.data['roles'];

            if (route.data['roles']) {
                //console.log(route.data['roles']);
                //alert("passo");
                // const expectedRole = route.data['roles'].some((r: Role) => user.roles?.includes(r));
                // if (expectedRole === false) {
                //     console.log("=>" + user.roles + ">>>" + expectedRole);

                if (route.data['roles'] && route.data['roles'].indexOf(user.roles) !== -1) {
                    //console.log("=>" + user.roles);
                    //  if (route.data.roles && route.data.roles.indexOf(currentUser.role) !== -1) {
                    // role not authorised so redirect to not-authorized page
                    //alert("non corrisponde");
                    this.router.navigate(['accessdenied']);
                    return false;
                }
                //alert("corrisponde");
            }

            // logged in so return true
            return true;
        }
        // else { //Area Else Solo ai fini di sviluppo
        //     // not logged in so redirect to login page with the return url
        //     this.router.navigate(['notificatore/versamento']);
        //     return false;
        // }
        else if (route.routeConfig.path == ''){
            return true;
        }
        else {
            // not logged in so redirect to login page with the return url
            this.router.navigate(['authentication/login'], { queryParams: { returnUrl: state.url } });
            return false;
        }
    }
}